<div class="d-flex flex-column justify-content-between">
  <div class="container-md mt-4">
    <tds-notifications
      [notifications]="dashboard_notifications"
      [notification_type]="storage_key"
      (mark_as_read)="markNotificationAsRead($event)"
    />

    <div class="row">
      <div class="col">
        <h2 class="my-0 display-2 welcome-text">
          {{ 'welcome' | translate: getLoggedinUserName() }}
        </h2>
      </div>
    </div>

    <ts-order-center class="row mt-3" />

    <ts-my-assets class="row mt-3" />

    <ts-my-orders class="row my-3" />
  </div>
</div>
